import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from './shared/services/storage.service';
import { AuthService } from './shared/services/auth.service';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss']
})

export class AppComponent {

	public appPages = [
		{
			title: 'Dashboard',
			url: '/board',
			icon: 'analytics-outline'
		},
		{
			title: 'Updates',
			url: '/updates',
			icon: 'newspaper-outline'
		},
		{
			title: 'Add request',
			url: '/add-request',
			icon: 'add-circle-outline'
		},
		{
			title: 'Logout',
			url: '/logout',
			icon: 'log-out-outline'
		},
	];

	constructor(
		private router: Router,
		private storageService: StorageService,
		public authService: AuthService
	) {
		this.authService.initializeUser();
	}

	logout(): void {
		// Remove the stored user data from localStorage
		this.storageService.removeFromStorage('user');

		// Redirect to the login page
		this.router.navigate(['/']);
	}
}
